var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 0c16.569 0 30 13.431 30 30 0 16.568-13.431 30-30 30C15.431 60 2 46.568 2 30 2 13.43 15.431 0 32 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.957 32.034h-2.81v10.021H28.98V32.034H27v-3.54h1.98v-2.29c0-1.639.78-4.204 4.204-4.204l3.085.013v3.436H34.03c-.367 0-.883.184-.883.965v2.083h3.174l-.364 3.537z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    cx: 32,
    cy: 32,
    r: 16
  }))));
};
export default SvgFacebook;